/*
 * @Author: yangyang yyangacom@163.com
 * @Date: 2023-06-07 16:47:37
 * @LastEditors: yangyang yyangacom@163.com
 * @LastEditTime: 2023-07-07 16:31:06
 * @FilePath: /dbrank_b/src/routes/visualChart/P1/index.js
 * @Description: p1
 */
import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './index.css';
import Stage from '../components/Stage';
import setChart from './chart';
import Chart from '../components/Chart';
import { Title6 } from '../components/Titles';
import TooltipDrawer from '../components/TooltipDrawer';
import Form from './Form';
import DBTable from '../components/DBTable';

class P8 extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartTitle: [],
      chartList: [],
      chartColorList: [],
      tableColumns: [],
      tableList: [],
    }
  }


  fillColor = (tableColumns) => {
    const border = `none`
    return tableColumns.map((item, index) => {
      return {
        ...item,
        style: {
          ...item.style,
          width: index > 0 ? 40: 'auto',
          height: 50,
          fontSize: 16,
          textAlign: 'center',
          fontWeight: 'normal',
          color: '#000',
          background: '#fff',
          border,
        },
        colStyle: (val, r, i) => {
          return {
            height: 50,
            fontSize: 16,
            textAlign: i > 0 ? 'center' : 'right',
            fontWeight: 'normal',
            background: '#fff',
            border,
          }
        },
        render: (val, record, i, index) => {
          if (index > 0) {
            return <span className={s.block} style={{ background: val }} />
          }
          return val;
        }
      }
    })
  }

  render() {
    const { chartTitle, chartList, chartColorList, tableColumns, tableList } = this.state;
    return (
      <Stage>
        <Title6 pageNumber="05">
          小罐茶VS竞品｜认知关键词对比
        </Title6>

        <div className={s.content}>
          <ul className={s.desWrapper}>
            <li contentEditable>
              在反映普通消费者认知的社交媒体类内容中，小罐茶在<span className={s.emphasis}>#品质</span>、
              <span className={s.emphasis}>#高端</span>、<span className={s.emphasis}>#礼</span>、
              <span className={s.emphasis}>#创新</span> 这四个方面均胜过竞品，
              <span className={s.emphasis}>#礼</span> 的词频最多，高达 <span className={s.emphasis}>20,648</span>次，且正面评价均为最多。竞品竹叶青四个关键词的词频均较低，
              尤其是<span className={s.emphasis}>#创新</span> ，仅出现<span className={s.emphasis}>791</span>次。
            </li>
            <li contentEditable>
              在新闻媒体相关报道内容中，小罐茶在<span className={s.emphasis}>#创新</span> 方面的词频最高，为<span className={s.emphasis}>3,885</span>次；
              <span className={s.emphasis}>#礼</span> 和<span className={s.emphasis}>#高端</span> 的词频相对较低，不及竞品竹叶青。
            </li>
          </ul>

          <div className={s.chartWrapper}>
            <TooltipDrawer
              style={{ width: '100%', height: '100%' }}
              formContent={<Form onChange={values => this.setState({ ...values })} />}>
              <Chart options={setChart({ label: chartTitle, list: chartList, color: chartColorList })} />
            </TooltipDrawer>
            <div className={s.tableWrapper}>
              <DBTable
                columns={this.fillColor(tableColumns)}
                data={tableList}
                style={{ boxShadow: 'none' }}
              />
            </div>
          </div>
        </div>
      </Stage>
    );
  }
}

export default withStyles(s)(P8);



// WEBPACK FOOTER //
// src/routes/visualChart/P8/index.js